import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';
import {Button, Col, Row} from "react-bootstrap";
import FormInput from "../../forms/FormInput";
import {connect} from "react-redux";
import Loader from "../Loader";
import {setNewProductGroupR} from "actions/ListActions";

class ProductGroupsNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      number: "",
    };
  }

  componentDidUpdate = (prevProps) => {
    if(prevProps.show !== this.props.show && this.props.show === true){
      this.setState({ number: "" })
    }
  }

  createProductGroup = () => {
    this.props.setNewProductGroupR({number: this.state.number})
    this.props.close();
  }

  render() {
    const { intl, show, close, appIntl} = this.props;
    const { number } = this.state;
    const messages = intl.messages;
    let createDisabled = true;
    if(number !== "" ){
      createDisabled = false;
    }

    return (
      <Modal show={show} onHide={close} bsSize="lg" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>{messages.new_product_group}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div>
                <h4></h4>
              </div>
              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm" >

                <FormInput
                  type="number"
                  label={messages.product_group_number}
                  name="number"
                  onChange={(name, value) => this.setState({ number: value })}
                  value={this.state.number}
                  disabled=""
                />

                {this.props.pending ?  <Loader/>:<></>}
                <Button onClick={()=>this.createProductGroup()}  disabled={createDisabled} bsStyle="primary"  className="pull-right" title="create_product_group">
                  <span className="hidden-xs">{messages.create_product_group}</span>
                </Button>
              </div>
            </Col>
          </Row>

        </Modal.Body>
      </Modal>
    );
  }
}


const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    pending: state.list.productGroups.pendingProductGroup
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setNewProductGroupR: (data) => {
      dispatch(setNewProductGroupR(data));
    },

  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ProductGroupsNew)
  )
);

